import { render, staticRenderFns } from "./CartToast.vue?vue&type=template&id=3b78ed0a&scoped=true"
import script from "./CartToast.vue?vue&type=script&lang=js"
export * from "./CartToast.vue?vue&type=script&lang=js"
import style0 from "./CartToast.vue?vue&type=style&index=0&id=3b78ed0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b78ed0a",
  null
  
)

export default component.exports